import React from 'react';
import { useTranslation } from 'react-i18next';
import { useAppSelector, shallowEqual } from 'store/hook';
import { Menu } from 'menu-items/type';
import { useStyles } from './index.style';
import MenuItem from './menuItem';

interface IHookProps {
  data: Menu;
}

const CMP: React.FC<IHookProps> = ({ data }) => {
  const user = useAppSelector(({ user }) => user.user, shallowEqual);

  const powerHidden = {
    agent: !user?.account?.agent?.showMenu,
    hiddenTopup: !user?.overview?.showTopupCostPreview && !user?.overview?.showUsdtTopupCostPreview
  };

  const { t } = useTranslation(['menu']);
  const { styles } = useStyles();
  return (
    <div className={styles.menuWrap}>
      {data.title ? <div className={styles.title}>{t(data.i18nTitle || '', { ns: 'menu' })}</div> : null}
      {data.children
        ? data.children.map((x) => {
            if (x._hidden && x._hidden(powerHidden)) {
              return null;
            }
            return <MenuItem key={x.title} data={x} />;
          })
        : null}
    </div>
  );
};

export default CMP;
